import React, { useState, useRef } from 'react';
import { Alert, CircularProgress, IconButton } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth0 } from '@auth0/auth0-react';
import { getApiUrl } from '../../utilities/consts';

export function LogoUploader({...params}){

    let callSign = params.callSign
    let affiliate = params.affiliate

    const [stagedLogo, setStagedLogo] = useState(null);
    const fileInputRef = useRef(null);
    const [error, setError] = useState(null);
    const [uploading, setUploading] = useState(false);
    const { getAccessTokenSilently } = useAuth0();

    const uploadLogo = async (channelID, logo) => {
        const apiUrl = getApiUrl();
        const accessToken = await getAccessTokenSilently({ authorizationParams: { scope: "write:channels" } });
        setUploading(true);

        // get presigned url to upload to
        const urlRes = await fetch(`${apiUrl}/logo/${channelID}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (!urlRes.ok) {
            console.error("Error fetching logo upload URL");
            setError("Error fetching logo upload URL");
            setUploading(false);
            return;
        }
        const { url } = await urlRes.json();

        // upload logo to bucket
        const uploadRes = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "image/svg+xml",
            },
            body: logo,
        });
        if (!uploadRes.ok) {
            console.error("Error uploading logo");
            setError("Error uploading logo");
            setUploading(false);
            return;
        }
        setUploading(false);
    }

    function checkFileExtension(file){
        var fileName = file.name
        const fileExtension = fileName.substring(fileName.length - 4)
        if (fileExtension !== ".svg") setError("The uploaded file must be an .svg file")
        else setError(null)
    }

    function handleEditLogo(event){
        event.preventDefault();
        fileInputRef.current.click();
    }

    const handleStageLogo = (event) => {
        const file = event.target.files[0];
        setStagedLogo(file);
        checkFileExtension(file)
    };

    const handleSubmitLogo = async () => {
        let channelID = callSign.toLowerCase() + "-" + affiliate.toLowerCase();
        const newFile = new File([stagedLogo], `${channelID}.svg`, {type: stagedLogo.type});
        await uploadLogo(channelID, newFile);
        setStagedLogo(null);
    }

    if (uploading) return <CircularProgress />

    return(
        <>
            <IconButton aria-label="upload" onClick={handleEditLogo}>
                <EditIcon />
            </IconButton>
            <input
                type="file"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleStageLogo}
            />
            {stagedLogo && (
                <>
                    {error ? 
                        (<Alert severity="error">{error}</Alert>)
                        :    
                        (<>
                            <IconButton aria-label="upload" onClick={handleSubmitLogo}>
                                <FileUploadIcon />
                            </IconButton>
                            <Alert severity="success">File format accepted:<pre/>Press the upload button to proceed.</Alert>
                        </>)
                    }
                    <p>{stagedLogo.name}</p>
                </>
            )}
        </>
    )
}
